var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.89,
    height: 21.762,
    viewBox: "0 0 17.89 21.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(-363.173 -430.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7452",
    "data-name": "Path 7452",
    d: "M24.389,21.034l-.006,0-.025-.014a.105.105,0,0,1-.027-.059V16.392l-.151.031a2.955,2.955,0,0,1-1.256,0l-.15-.031v4.567a1.61,1.61,0,0,0,.487,1.156,1.593,1.593,0,0,0,.575.381c.027.01.67.23.67.787v.166a.788.788,0,0,1-.8.8H10.527a.79.79,0,0,1-.8-.8v-.166c0-.557.645-.777.68-.789a1.738,1.738,0,0,0,.574-.378,1.654,1.654,0,0,0,.48-1.157V15.387a5.675,5.675,0,0,1,4.516-5.546,1.981,1.981,0,0,1,.228-.034,5.721,5.721,0,0,1,2.052.034A5.654,5.654,0,0,1,20.917,11.2l.094.087.085-.1a3.332,3.332,0,0,1,1-.78l.154-.078-.122-.122a6.946,6.946,0,0,0-2.933-1.738V8.308a2.055,2.055,0,0,0-.6-1.464,2.113,2.113,0,0,0-1.658-.6A2.142,2.142,0,0,0,15.043,8.4v.071a7.249,7.249,0,0,0-5.137,6.912v5.572a.126.126,0,0,1-.024.058l-.036.025a2.423,2.423,0,0,0-1.673,2.241v.166A2.357,2.357,0,0,0,10.527,25.8h3.725a2.97,2.97,0,0,0,5.733,0H23.71a2.356,2.356,0,0,0,2.353-2.354v-.166a2.442,2.442,0,0,0-1.674-2.249M18.307,25.8a1.425,1.425,0,0,1-2.375,0ZM17.069,7.788a.53.53,0,0,1,.413.156.521.521,0,0,1,.139.238c-.167-.011-.335-.016-.5-.016s-.32,0-.487.015a.554.554,0,0,1,.437-.393Z",
    transform: "translate(355 424)",
    fill: "#023f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7453",
    "data-name": "Path 7453",
    d: "M23.552,13.228a.606.606,0,0,0,.606-.6l.179-4.537c0-.346-.457-.559-.785-.559s-.785.256-.785.615l.179,4.477a.607.607,0,0,0,.606.606",
    transform: "translate(355 424)",
    fill: "#023f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7454",
    "data-name": "Path 7454",
    d: "M23.552,15.21a.787.787,0,1,0-.787-.786.788.788,0,0,0,.787.786",
    transform: "translate(355 424)",
    fill: "#023f7f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.277de04a7f638b2f757aaca10608ebc7.svg";
export { ForwardRef as ReactComponent };